export const I18N_EN = {
  'billing.F.long': "Free",
  'billing.B.long': "Free if confirmed as a bug",
  'billing.Q.long': "Paid - you get a quote first",
  'billing.S.long': "Sponsored - cost shared, quote first",
  'billing.B.short': "Free once accepted as a bug",
  'billing.Q.short': "Paid after an accepted quote",
  'billing.S.short': "Sponsored - cost shared with other customers",
  'billing.invoiced': "Invoiced",
  'billing.badge.billable': "Billable",
  'billing.badge.discount': "Suggested discount",
  'billing.edit_quote': "Edit quote",
  'billing.save_quote': "Save quote",
  'billing.cancel': "Cancel",
  'board.sort': "Sort",
  'board.sort.default': "Default",
  'board.sort.urgency': "Urgency",
  'board.sort.updated': "Recently updated",
  'board.sort.stale': "Longest not updated",
  'board.sort.all': "Sort all lanes",
  'billing.quote': "Quote",
  'billing.hours': "Expected hours",
  'billing.amount': "Expected amount",
  'billing.waiting_quote': "Waiting for a quote from ActFact",
  'billing.waiting_quote_kpi': "Waiting for quote",
  'create.type.help': "What kind of request is this?",
  'create.back': "Back",
  'create.review.quote_note': "This request will first wait for a quote from ActFact.",
  'app.brand': 'Support Portal',
  'app.search': 'Search requests, invoices, orders…',
  'app.kbd_search': '⌘K',
  'app.notifications': 'Notifications',
  'notif.empty': 'No notifications.',
  'help.title': 'Help',
  'help.close': 'Close',
  'help.getting_started': 'Getting started',
  'help.step1': 'Submit a request using the New Request button.',
  'help.step2': 'Track progress on the board, list, or timeline view.',
  'help.step3': 'Reply to agent comments directly in the request thread.',
  'help.step4': 'Mark a request as resolved once your issue is fixed.',
  'help.keyboard_shortcuts': 'Keyboard shortcuts',
  'help.shortcut.focus_search': 'Focus search',
  'help.shortcut.close_panel': 'Close panel / clear search',
  'help.contact_support': 'Contact support',
  'help.contact_prefix': "Can't find an answer?",
  'app.help': 'Help',
  'app.role.customer': 'Customer view',
  'app.role.agent': 'Agent view',
  'app.menu': 'Menu',
  'app.settings': 'Settings',
  'app.logout': 'Log out',
  'nav.helpdesk': 'Helpdesk',
  'nav.requests': 'Requests',
  'nav.new_request': 'New Request',
  'nav.business': 'Business',
  'nav.orders': 'Orders',
  'nav.invoices': 'Invoices',
  'nav.payments': 'Payments',
  'nav.assets': 'My Systems',
  'nav.assets_agent': 'Systems',
  'nav.account': 'Account',
  'nav.request_cluster': 'Request Cluster',
  'nav.about': 'About ActFact',
  'req.title': 'Requests',
  'req.subtitle': 'Track every request you have raised with ActFact support.',
  'req.subtitle_agent': 'All requests across customers — pick yours from the scope filter.',
  'req.subtitle_company': 'Showing every request across your organisation.',
  'crumb.my_requests': 'My Requests',
  'crumb.all_requests': 'All Requests',
  'crumb.whole_company': 'Whole Company',
  'crumb.my_orders': 'My Orders',
  'crumb.my_invoices': 'My Invoices',
  'crumb.my_payments': 'My Payments',
  'crumb.my_assets': 'My Systems',
  'crumb.assets_agent': 'Systems',
  'crumb.about': 'About',
  'assets.title': 'My Systems',
  'assets.title_agent': 'Systems',
  'assets.subtitle': 'The systems ActFact manages for you, and their update history.',
  'assets.subtitle_agent': 'Every customer system ActFact manages, and its update history.',
  'assets.no_versions': 'No update history yet.',
  'assets.current_version': 'Current version',
  'assets.planned': 'Planned',
  'assets.applied': 'Applied',
  'assets.cancelled': 'Cancelled',
  'assets.rolled_back': 'Rolled back',
  'req.new': 'New Request',
  'req.view.board': 'Board',
  'req.view.timeline': 'Timeline',
  'req.filter.status': 'Status',
  'req.filter.type': 'Type',
  'req.filter.date': 'Date',
  'req.filter.search': 'Search',
  'req.filter.all': 'All',
  'req.filter.company': 'Whole company',
  'req.filter.scope': 'Scope',
  'req.filter.title': 'Filters',
  'req.filter.bpartner': 'Business partner',
  'req.filter.type_to_search': 'Type to search…',
  'req.filter.no_matches': 'No matches',
  'req.filter.search_placeholder': 'Search by summary, ticket no., document…',
  'req.filter.range.any': 'Any time',
  'req.filter.range.7d': 'Last 7 days',
  'req.filter.range.30d': 'Last 30 days',
  'req.filter.range.90d': 'Last 90 days',
  'req.filter.scope.all': 'All requests',
  'req.filter.scope.assigned_to_me': 'Only assigned to me',
  'req.filter.scope.created_by_me': 'Created by me',
  'req.filter.scope.waiting_for_me': 'Waiting for me',
  'req.filter.scope.mine': 'My requests',
  'req.detail.asm': 'Assigned ASM',
  'req.col.created': 'Created',
  'req.col.updated': 'Updated',
  'req.tab.activity': 'Activity',
  'req.tab.comments': 'Comments',
  'req.tab.attachments': 'Attachments',
  'req.tab.linked': 'Linked',
  'req.detail.add_comment': 'Write a reply…',
  'req.detail.send': 'Post Reply',
  'req.detail.reopen': 'Re-open Request',
  'req.detail.contact': 'Contact',
  'req.detail.cluster': 'Cluster',
  'req.detail.created_by': 'Reported by',
  'req.detail.priority': 'Priority',
  'req.detail.module': 'Module',
  'create.title': 'New Request',
  'create.field.summary': 'Summary',
  'create.field.summary.help': 'A short, clear sentence. e.g. "Cannot post AP invoice 1023456".',
  'create.field.type': 'Type',
  'create.field.bpartner': 'Business partner',
  'create.field.bpartner.placeholder': 'Select a business partner…',
  'create.field.bpartner.own_org': 'Own organization',
  'create.field.bpartner.help': 'Choose the customer this request is for, or Own organization if it isn’t for a customer.',
  'create.field.contact': 'Contact',
  'create.field.contact.placeholder': 'Select a contact…',
  'create.field.module': 'Module',
  'create.field.priority': 'Priority',
  'create.field.priority.help': 'How urgent is this for you to be unblocked?',
  'create.field.description': 'Description',
  'create.field.description.help': 'What did you do, what did you expect, what happened? Paste screenshots directly.',
  'create.field.doc': 'Related Document',
  'create.field.doc.help': 'Optional. e.g. invoice number, sales order, or report.',
  'create.field.cluster': 'Request Cluster',
  'create.field.cluster.placeholder': 'Select a request cluster…',
  'create.field.cluster.help': 'Optional. Group this request under a planned cluster of work.',
  'create.field.attachments': 'Attachments',
  'create.field.attachments.help': 'Drop files or paste images. Max 25 MB per file.',
  'create.submit': 'Submit Request',
  'create.submitting': 'Submitting…',
  'create.cancel': 'Cancel',
  'create.chat.intro': "Hi. I'll open a ticket with you. Start by telling me what's wrong.",
  'create.similar.checking': 'Checking for existing tickets…',
  'create.similar.found': 'We found open tickets that may be about the same issue. If one of them matches, link your ticket to it so our team can handle them together.',
  'create.similar.privacy': 'For privacy, tickets of other customers only show their title.',
  'create.similar.link': 'Same issue, link to this',
  'create.similar.reply': 'Reply to this ticket',
  'create.similar.internal': 'Post reply as internal note',
  'create.similar.none': 'None of these, continue',
  'create.similar.linked': 'Related to',
  'account.title': 'My Account',
  'account.profile.details': "Details",
  'account.avatar.upload': "Upload picture",
  'account.avatar.replace': "Replace picture",
  'account.avatar.remove': "Remove picture",
  'account.avatar.hint': "PNG, JPEG or WebP, up to 2 MB.",
  'account.avatar.too_big': "The picture is larger than 2 MB. Choose a smaller picture.",
  'account.avatar.bad_type': "Only PNG, JPEG or WebP pictures can be used.",
  'account.avatar.failed': "The picture could not be saved. Try again.",
  'account.pref.language.help': "The language of the portal.",
  'account.pref.notifications.help': "How you are told about updates on your requests.",
  'account.pref.notify.E': "Email",
  'account.pref.notify.N': "Portal notification only",
  'account.pref.notify.B': "Email and portal notification",
  'account.pref.notify.X': "None",
  'account.pref.view': "Default view",
  'account.pref.view.help': "The view the Requests page opens with on this device.",
  'account.pref.saved': "Saved",
  'account.pref.save_failed': "Could not save. Try again.",
  'about.intro': "We are here to help you get the most out of ActFact.",
  'account.profile': 'Profile',
  'account.profile.note': 'Please contact us if you wish to change your details.',
  'account.field.name': 'Name',
  'account.field.email': 'E-mail',
  'account.field.company': 'Organisation',
  'account.field.phone': 'Telephone',
  'account.field.address': 'Address',
  'account.field.city': 'City',
  'account.field.country': 'Country',
  'account.field.role': 'Role',
  'account.preferences': 'Preferences',
  'account.pref.language': 'Language',
  'account.pref.language.value': 'English (en-US)',
  'account.pref.notifications': 'Email notifications',
  'account.security': 'Security',
  'account.security.password': 'Change password',
  'account.field.current_password': 'Current Password',
  'account.field.new_password': 'New Password',
  'account.field.confirm_password': 'Confirm Password',
  'account.password_mismatch': 'Passwords do not match.',
  'account.save': 'Save',
  'account.tokens': "API tokens",
  'account.tokens.intro': "Personal tokens for scripts and integrations (for example Claude). A token acts as you, with your rights; keep it secret.",
  'account.tokens.new': "New token",
  'account.tokens.none': "No active tokens.",
  'account.tokens.inactive': "Expired and revoked",
  'account.tokens.name': "Name",
  'account.tokens.name.placeholder': "e.g. Claude on my laptop",
  'account.tokens.expiry': "Expires",
  'account.tokens.expiry.30': "In 30 days",
  'account.tokens.expiry.90': "In 90 days",
  'account.tokens.expiry.365': "In 1 year",
  'account.tokens.expiry.never': "Never",
  'account.tokens.scope_note': "A token can only do what you tick here, and never more than you can do in the portal yourself. Revoke it as soon as you no longer need it.",
  'account.tokens.create': "Create token",
  'account.tokens.create_failed': "Could not create the token.",
  'account.tokens.cancel': "Cancel",
  'account.tokens.copy_now': "Copy the token now. It is not stored and will not be shown again.",
  'account.tokens.copy': "Copy",
  'account.tokens.copied': "Copied",
  'account.tokens.usage': "Send it as the header",
  'account.tokens.done': "Done",
  'account.tokens.created': "created",
  'account.tokens.expires': "expires",
  'account.tokens.no_expiry': "no expiry",
  'account.tokens.last_used': "last used",
  'account.tokens.never_used': "never used",
  'account.tokens.revoke': "Revoke",
  'account.tokens.revoke_title': "Revoke this token?",
  'account.tokens.revoke_note': "Scripts that use it stop working immediately. This can't be undone.",
  'account.tokens.revoke_failed': "Could not revoke the token.",
  'account.tokens.status.active': "Active",
  'account.tokens.status.expired': "Expired",
  'account.tokens.status.revoked': "Revoked",
  'account.tokens.scopes': "Permissions",
  'account.tokens.scope.read': "Read",
  'account.tokens.scope.read.hint': "View requests, lookups and your own time. Every token can read.",
  'account.tokens.scope.requests_write': "Create requests and comment",
  'account.tokens.scope.requests_write.hint': "New requests, comments and attachments",
  'account.tokens.scope.requests_manage': "Manage requests",
  'account.tokens.scope.requests_manage.hint': "Change fields, status, assignee and watchers (agents)",
  'account.tokens.scope.timesheets_write': "Write time",
  'account.tokens.scope.timesheets_write.hint': "Log, change and delete your own time entries (agents)",
  'idle.title': 'Still there?',
  'idle.body': "You'll be logged out in {seconds}s due to inactivity.",
  'idle.stay': 'Stay signed in',
  'idle.logout_now': 'Log out now',
  'session_end.title': 'Session ending soon',
  'session_end.body': 'For security, your session ends at {time}. Save your work - you will need to log in again after that.',
  'session_end.ok': 'OK',
  'about.title': 'About ActFact',
  'about.support': 'Support',
  'about.support.email': 'support@actfact.com',
  'about.support.phone': '+31 (0) 53 432 20 22',
  'about.legal': 'Legal',
  'about.legal.privacy': 'Privacy Policy',
  'about.status': 'System Status',
  'about.status.operational': 'All systems operational',
  'common.you': 'You',
  'common.support': 'ActFact Support',
  'common.minutes_ago': 'min ago',
  'common.hours_ago': 'h ago',
  'common.days_ago': 'd ago',
  'common.yesterday': 'Yesterday',
  'common.today': 'Today',
  'login.header.brand': 'Support Portal',
  'login.header.login': 'Log in',
  'login.tab': 'Login',
  'login.field.username': 'Username',
  'login.field.password': 'Password',
  'login.forgot': 'Forgot password?',
  'login.submit': 'Log in',
  'login.submit.loading': 'Working…',
  'login.error.username_required': 'Please fill in your username.',
  'login.error.password_required': 'Please fill in your password.',
  'login.error.generic': 'Login failed. Please try again.',
  'login.twofactor.title': 'Two-factor verification',
  'login.twofactor.body': 'Enter the code from your authenticator app.',
  'login.twofactor.field.code': 'Verification code',
  'login.twofactor.error.code_required': 'Please enter the verification code.',
  'login.twofactor.back': 'Back',
  'login.twofactor.submit': 'Verify',
  'login.twofactor.submit.loading': 'Verifying…',
  'login.enroll.title': 'Set up two-factor authentication',
  'login.enroll.body': 'Two-factor authentication is required for your account. Scan the QR code with an authenticator app (e.g. Google Authenticator, Authy), then enter the code it shows.',
  'login.enroll.secret_label': 'Or enter this key manually:',
  'login.enroll.field.code': 'Verification code',
  'login.enroll.error.code_required': 'Please enter the verification code.',
  'login.enroll.error.load_failed': 'Could not load the QR code. Please try again.',
  'login.enroll.back': 'Back',
  'login.enroll.submit': 'Verify & enable',
  'login.enroll.submit.loading': 'Verifying…',
  'login.info.helpdesk.title': 'Helpdesk',
  'login.info.helpdesk.body': 'ActFact supports its customers with its own helpdesk. Our staff are fully familiar with your specifications and help you as quickly as possible with questions, changes or issues.',
  'login.info.availability.title': 'Availability',
  'login.info.availability.body1': 'Our helpdesk is available on business days (NL) from 08:30 to 17:00 (NL CET/CEST) at phone number +31 (0) 53 432 20 22. You can also contact the helpdesk by email, the address is',
  'login.info.availability.body2': ". Outside office hours, customers with a valid SLA can reach us 24/7. For more information, you can log in to 'My ActFact' using the provided password.",
};

export const I18N_NL = {
  'billing.F.long': "Gratis",
  'billing.B.long': "Gratis indien bevestigd als bug",
  'billing.Q.long': "Betaald - u ontvangt eerst een offerte",
  'billing.S.long': "Gesponsord - kosten gedeeld, eerst offerte",
  'billing.B.short': "Gratis zodra geaccepteerd als bug",
  'billing.Q.short': "Betaald na een geaccepteerde offerte",
  'billing.S.short': "Gesponsord - kosten gedeeld met andere klanten",
  'billing.invoiced': "Gefactureerd",
  'billing.badge.billable': "Factureerbaar",
  'billing.badge.discount': "Voorgestelde korting",
  'billing.edit_quote': "Offerte wijzigen",
  'billing.save_quote': "Offerte opslaan",
  'billing.cancel': "Annuleren",
  'board.sort': "Sorteren",
  'board.sort.default': "Standaard",
  'board.sort.urgency': "Urgentie",
  'board.sort.updated': "Recent bijgewerkt",
  'board.sort.stale': "Langst niet bijgewerkt",
  'board.sort.all': "Sorteer alle kolommen",
  'billing.quote': "Offerte",
  'billing.hours': "Verwachte uren",
  'billing.amount': "Verwacht bedrag",
  'billing.waiting_quote': "Wacht op een offerte van ActFact",
  'billing.waiting_quote_kpi': "Wacht op offerte",
  'create.type.help': "Wat voor soort verzoek is dit?",
  'create.back': "Terug",
  'create.review.quote_note': "Dit verzoek wacht eerst op een offerte van ActFact.",
  'app.brand': 'Support Portal',
  'app.search': 'Zoek verzoeken, facturen, orders…',
  'app.kbd_search': '⌘K',
  'app.notifications': 'Meldingen',
  'notif.empty': 'Geen meldingen.',
  'help.title': 'Help',
  'help.close': 'Sluiten',
  'help.getting_started': 'Aan de slag',
  'help.step1': 'Dien een verzoek in via de knop Nieuw verzoek.',
  'help.step2': 'Volg de voortgang via het bord, de lijst of de tijdlijn.',
  'help.step3': 'Reageer direct op berichten van de medewerker in de verzoekthread.',
  'help.step4': 'Markeer een verzoek als opgelost zodra uw probleem verholpen is.',
  'help.keyboard_shortcuts': 'Sneltoetsen',
  'help.shortcut.focus_search': 'Zoekbalk focussen',
  'help.shortcut.close_panel': 'Paneel sluiten / zoekopdracht wissen',
  'help.contact_support': 'Contact opnemen met support',
  'help.contact_prefix': 'Geen antwoord gevonden?',
  'app.help': 'Help',
  'app.role.customer': 'Klantweergave',
  'app.role.agent': 'Medewerkerweergave',
  'app.menu': 'Menu',
  'app.settings': 'Instellingen',
  'app.logout': 'Uitloggen',
  'nav.helpdesk': 'Helpdesk',
  'nav.requests': 'Verzoeken',
  'nav.new_request': 'Nieuw verzoek',
  'nav.business': 'Zakelijk',
  'nav.orders': 'Orders',
  'nav.invoices': 'Facturen',
  'nav.payments': 'Betalingen',
  'nav.assets': 'Mijn Systemen',
  'nav.assets_agent': 'Systemen',
  'nav.account': 'Account',
  'nav.request_cluster': 'Verzoekcluster',
  'nav.about': 'Over ActFact',
  'req.title': 'Verzoeken',
  'req.subtitle': 'Volg elk verzoek dat u bij ActFact support heeft ingediend.',
  'req.subtitle_agent': 'Alle verzoeken van alle klanten — gebruik het bereikfilter om alleen uw eigen verzoeken te tonen.',
  'req.subtitle_company': 'Toont elk verzoek binnen uw organisatie.',
  'crumb.my_requests': 'Mijn Verzoeken',
  'crumb.all_requests': 'Alle Verzoeken',
  'crumb.whole_company': 'Hele Organisatie',
  'crumb.my_orders': 'Mijn Orders',
  'crumb.my_invoices': 'Mijn Facturen',
  'crumb.my_payments': 'Mijn Betalingen',
  'crumb.my_assets': 'Mijn Systemen',
  'crumb.assets_agent': 'Systemen',
  'assets.title': 'Mijn Systemen',
  'assets.title_agent': 'Systemen',
  'assets.subtitle': 'De systemen die ActFact voor u beheert, en hun updategeschiedenis.',
  'assets.subtitle_agent': 'Elk klantsysteem dat ActFact beheert, en de updategeschiedenis ervan.',
  'assets.no_versions': 'Nog geen updategeschiedenis.',
  'assets.current_version': 'Huidige versie',
  'assets.planned': 'Gepland',
  'assets.applied': 'Toegepast',
  'assets.cancelled': 'Geannuleerd',
  'assets.rolled_back': 'Teruggedraaid',
  'crumb.about': 'Over',
  'req.new': 'Nieuw verzoek',
  'req.view.board': 'Bord',
  'req.view.timeline': 'Tijdlijn',
  'req.filter.status': 'Status',
  'req.filter.type': 'Type',
  'req.filter.date': 'Datum',
  'req.filter.search': 'Zoeken',
  'req.filter.all': 'Alles',
  'req.filter.company': 'Hele organisatie',
  'req.filter.scope': 'Bereik',
  'req.filter.title': 'Filters',
  'req.filter.bpartner': 'Relatie',
  'req.filter.type_to_search': 'Typ om te zoeken…',
  'req.filter.no_matches': 'Geen resultaten',
  'req.filter.search_placeholder': 'Zoek op samenvatting, ticketnr., document…',
  'req.filter.range.any': 'Elk moment',
  'req.filter.range.7d': 'Laatste 7 dagen',
  'req.filter.range.30d': 'Laatste 30 dagen',
  'req.filter.range.90d': 'Laatste 90 dagen',
  'req.filter.scope.all': 'Alle verzoeken',
  'req.filter.scope.assigned_to_me': 'Alleen aan mij toegewezen',
  'req.filter.scope.created_by_me': 'Door mij aangemaakt',
  'req.filter.scope.waiting_for_me': 'Wacht op mij',
  'req.filter.scope.mine': 'Mijn verzoeken',
  'req.detail.asm': 'Toegewezen ASM',
  'req.col.created': 'Aangemaakt',
  'req.col.updated': 'Bijgewerkt',
  'req.tab.activity': 'Activiteit',
  'req.tab.comments': 'Reacties',
  'req.tab.attachments': 'Bijlagen',
  'req.tab.linked': 'Gekoppeld',
  'req.detail.add_comment': 'Schrijf een reactie…',
  'req.detail.send': 'Reactie plaatsen',
  'req.detail.reopen': 'Verzoek heropenen',
  'req.detail.contact': 'Contactpersoon',
  'req.detail.cluster': 'Cluster',
  'req.detail.created_by': 'Gemeld door',
  'req.detail.priority': 'Prioriteit',
  'req.detail.module': 'Module',
  'create.title': 'Nieuw verzoek',
  'create.field.summary': 'Samenvatting',
  'create.field.summary.help': 'Een korte, duidelijke zin. Bijv. "Kan AP-factuur 1023456 niet boeken".',
  'create.field.type': 'Type',
  'create.field.bpartner': 'Relatie',
  'create.field.bpartner.placeholder': 'Selecteer een relatie…',
  'create.field.bpartner.own_org': 'Eigen organisatie',
  'create.field.bpartner.help': 'Kies de klant waarvoor dit verzoek is, of Eigen organisatie als het niet voor een klant is.',
  'create.field.contact': 'Contactpersoon',
  'create.field.contact.placeholder': 'Selecteer een contactpersoon…',
  'create.field.module': 'Module',
  'create.field.priority': 'Prioriteit',
  'create.field.priority.help': 'Hoe urgent is dit voor u om verder te kunnen?',
  'create.field.description': 'Omschrijving',
  'create.field.description.help': 'Wat deed u, wat verwachtte u, wat gebeurde er? Plak screenshots direct.',
  'create.field.doc': 'Gerelateerd document',
  'create.field.doc.help': 'Optioneel. Bijv. factuurnummer, verkooporder of rapport.',
  'create.field.cluster': 'Requestcluster',
  'create.field.cluster.placeholder': 'Selecteer een requestcluster…',
  'create.field.cluster.help': 'Optioneel. Groepeer deze aanvraag onder een gepland cluster van werk.',
  'create.field.attachments': 'Bijlagen',
  'create.field.attachments.help': 'Sleep bestanden of plak afbeeldingen. Max 25 MB per bestand.',
  'create.submit': 'Verzoek indienen',
  'create.submitting': 'Bezig met indienen…',
  'create.cancel': 'Annuleren',
  'create.chat.intro': 'Hallo. Ik open samen met u een ticket. Vertel eerst wat er mis is.',
  'create.similar.checking': 'Controleren op bestaande tickets…',
  'create.similar.found': 'We hebben openstaande tickets gevonden die over hetzelfde probleem kunnen gaan. Als er een overeenkomt, koppel uw ticket eraan zodat ons team ze samen kan behandelen.',
  'create.similar.privacy': 'Om privacyredenen tonen tickets van andere klanten alleen hun titel.',
  'create.similar.link': 'Zelfde probleem, hieraan koppelen',
  'create.similar.reply': 'Op dit ticket reageren',
  'create.similar.internal': 'Reactie als interne notitie plaatsen',
  'create.similar.none': 'Geen van deze, doorgaan',
  'create.similar.linked': 'Gerelateerd aan',
  'account.title': 'Mijn account',
  'account.profile.details': "Gegevens",
  'account.avatar.upload': "Foto uploaden",
  'account.avatar.replace': "Foto vervangen",
  'account.avatar.remove': "Foto verwijderen",
  'account.avatar.hint': "PNG, JPEG of WebP, maximaal 2 MB.",
  'account.avatar.too_big': "De foto is groter dan 2 MB. Kies een kleinere foto.",
  'account.avatar.bad_type': "Alleen PNG-, JPEG- of WebP-afbeeldingen kunnen worden gebruikt.",
  'account.avatar.failed': "De foto kon niet worden opgeslagen. Probeer het opnieuw.",
  'account.pref.language.help': "De taal van het portaal.",
  'account.pref.notifications.help': "Hoe u op de hoogte wordt gebracht van updates op uw verzoeken.",
  'account.pref.notify.E': "E-mail",
  'account.pref.notify.N': "Alleen portaalmelding",
  'account.pref.notify.B': "E-mail en portaalmelding",
  'account.pref.notify.X': "Geen",
  'account.pref.view': "Standaardweergave",
  'account.pref.view.help': "De weergave waarmee de pagina Verzoeken op dit apparaat opent.",
  'account.pref.saved': "Opgeslagen",
  'account.pref.save_failed': "Opslaan mislukt. Probeer het opnieuw.",
  'about.intro': "Wij helpen u graag om het meeste uit ActFact te halen.",
  'account.profile': 'Profiel',
  'account.profile.note': 'Neem contact met ons op als u uw gegevens wilt wijzigen.',
  'account.field.name': 'Naam',
  'account.field.email': 'E-mail',
  'account.field.company': 'Organisatie',
  'account.field.phone': 'Telefoon',
  'account.field.address': 'Adres',
  'account.field.city': 'Plaats',
  'account.field.country': 'Land',
  'account.field.role': 'Rol',
  'account.preferences': 'Voorkeuren',
  'account.pref.language': 'Taal',
  'account.pref.language.value': 'Nederlands (nl-NL)',
  'account.pref.notifications': 'E-mailmeldingen',
  'account.security': 'Beveiliging',
  'account.security.password': 'Wachtwoord wijzigen',
  'account.field.current_password': 'Huidig wachtwoord',
  'account.field.new_password': 'Nieuw wachtwoord',
  'account.field.confirm_password': 'Bevestig wachtwoord',
  'account.password_mismatch': 'Wachtwoorden komen niet overeen.',
  'account.save': 'Opslaan',
  'account.tokens': "API-tokens",
  'account.tokens.intro': "Persoonlijke tokens voor scripts en koppelingen (bijvoorbeeld Claude). Een token werkt namens u, met uw rechten; houd het geheim.",
  'account.tokens.new': "Nieuw token",
  'account.tokens.none': "Geen actieve tokens.",
  'account.tokens.inactive': "Verlopen en ingetrokken",
  'account.tokens.name': "Naam",
  'account.tokens.name.placeholder': "bijv. Claude op mijn laptop",
  'account.tokens.expiry': "Verloopt",
  'account.tokens.expiry.30': "Over 30 dagen",
  'account.tokens.expiry.90': "Over 90 dagen",
  'account.tokens.expiry.365': "Over 1 jaar",
  'account.tokens.expiry.never': "Nooit",
  'account.tokens.scope_note': "Een token kan alleen wat u hier aanvinkt, en nooit meer dan u zelf in het portaal kunt. Trek het in zodra u het niet meer nodig heeft.",
  'account.tokens.create': "Token aanmaken",
  'account.tokens.create_failed': "Het token kon niet worden aangemaakt.",
  'account.tokens.cancel': "Annuleren",
  'account.tokens.copy_now': "Kopieer het token nu. Het wordt niet opgeslagen en niet nog eens getoond.",
  'account.tokens.copy': "Kopiëren",
  'account.tokens.copied': "Gekopieerd",
  'account.tokens.usage': "Stuur het mee als header",
  'account.tokens.done': "Klaar",
  'account.tokens.created': "aangemaakt",
  'account.tokens.expires': "verloopt",
  'account.tokens.no_expiry': "verloopt niet",
  'account.tokens.last_used': "laatst gebruikt",
  'account.tokens.never_used': "nooit gebruikt",
  'account.tokens.revoke': "Intrekken",
  'account.tokens.revoke_title': "Dit token intrekken?",
  'account.tokens.revoke_note': "Scripts die het gebruiken werken direct niet meer. Dit kan niet ongedaan worden gemaakt.",
  'account.tokens.revoke_failed': "Het token kon niet worden ingetrokken.",
  'account.tokens.status.active': "Actief",
  'account.tokens.status.expired': "Verlopen",
  'account.tokens.status.revoked': "Ingetrokken",
  'account.tokens.scopes': "Rechten",
  'account.tokens.scope.read': "Lezen",
  'account.tokens.scope.read.hint': "Verzoeken, keuzelijsten en uw eigen uren bekijken. Elk token kan lezen.",
  'account.tokens.scope.requests_write': "Verzoeken aanmaken en reageren",
  'account.tokens.scope.requests_write.hint': "Nieuwe verzoeken, reacties en bijlagen",
  'account.tokens.scope.requests_manage': "Verzoeken beheren",
  'account.tokens.scope.requests_manage.hint': "Velden, status, behandelaar en volgers wijzigen (medewerkers)",
  'account.tokens.scope.timesheets_write': "Uren schrijven",
  'account.tokens.scope.timesheets_write.hint': "Uw eigen uren registreren, wijzigen en verwijderen (medewerkers)",
  'idle.title': 'Nog aanwezig?',
  'idle.body': 'U wordt over {seconds}s uitgelogd wegens inactiviteit.',
  'idle.stay': 'Aangemeld blijven',
  'idle.logout_now': 'Nu uitloggen',
  'session_end.title': 'Sessie verloopt binnenkort',
  'session_end.body': 'Om veiligheidsredenen eindigt uw sessie om {time}. Sla uw werk op - daarna moet u opnieuw inloggen.',
  'session_end.ok': 'OK',
  'about.title': 'Over ActFact',
  'about.support': 'Support',
  'about.support.email': 'support@actfact.com',
  'about.support.phone': '+31 (0) 53 432 20 22',
  'about.legal': 'Juridisch',
  'about.legal.privacy': 'Privacybeleid',
  'about.status': 'Systeemstatus',
  'about.status.operational': 'Alle systemen operationeel',
  'common.you': 'U',
  'common.support': 'ActFact Support',
  'common.minutes_ago': 'min geleden',
  'common.hours_ago': 'u geleden',
  'common.days_ago': 'd geleden',
  'common.yesterday': 'Gisteren',
  'common.today': 'Vandaag',
  'login.header.brand': 'Support Portal',
  'login.header.login': 'Inloggen',
  'login.tab': 'Login',
  'login.field.username': 'Gebruiker',
  'login.field.password': 'Wachtwoord',
  'login.forgot': 'Wachtwoord vergeten?',
  'login.submit': 'Inloggen',
  'login.submit.loading': 'Bezig…',
  'login.error.username_required': 'Vul uw gebruikersnaam in.',
  'login.error.password_required': 'Vul uw wachtwoord in.',
  'login.error.generic': 'Inloggen mislukt. Probeer het opnieuw.',
  'login.twofactor.title': 'Tweestapsverificatie',
  'login.twofactor.body': 'Voer de code uit uw authenticator-app in.',
  'login.twofactor.field.code': 'Verificatiecode',
  'login.twofactor.error.code_required': 'Vul de verificatiecode in.',
  'login.twofactor.back': 'Terug',
  'login.twofactor.submit': 'Verifiëren',
  'login.twofactor.submit.loading': 'Verifiëren…',
  'login.enroll.title': 'Tweestapsverificatie instellen',
  'login.enroll.body': 'Tweestapsverificatie is verplicht voor uw account. Scan de QR-code met een authenticator-app (bijv. Google Authenticator, Authy) en voer de code in die deze toont.',
  'login.enroll.secret_label': 'Of voer deze sleutel handmatig in:',
  'login.enroll.field.code': 'Verificatiecode',
  'login.enroll.error.code_required': 'Vul de verificatiecode in.',
  'login.enroll.error.load_failed': 'Kon de QR-code niet laden. Probeer het opnieuw.',
  'login.enroll.back': 'Terug',
  'login.enroll.submit': 'Verifiëren & inschakelen',
  'login.enroll.submit.loading': 'Verifiëren…',
  'login.info.helpdesk.title': 'Helpdesk',
  'login.info.helpdesk.body': 'ActFact biedt haar klanten ondersteuning met een eigen helpdesk. Onze medewerkers zijn volledig op de hoogte van uw specificaties en helpen u zo snel mogelijk met vragen, aanpassingen of problemen.',
  'login.info.availability.title': 'Bereikbaarheid',
  'login.info.availability.body1': 'Onze helpdesk is op kantoordagen (NL) bereikbaar van 08:30 uur tot 17:00 uur (NL CET/CEST) op telefoonnummer +31 (0) 53 432 20 22. U kunt ook per email contact opnemen met de helpdesk, het adres is',
  'login.info.availability.body2': ". Buiten kantoor uren kunnen opdrachtgevers met een geldige SLA 24/7 contact opnemen. Voor meer informatie kunt u inloggen op 'Mijn ActFact' middels het verstrekte wachtwoord.",
};

export { t } from './i18n.jsx';

const NOW = new Date();

function daysAgo(n, h = 0, m = 0) {
  const d = new Date(NOW);
  d.setDate(d.getDate() - n);
  d.setHours(h || (10 + (n % 5)), m || ((n * 7) % 60), 0, 0);
  return d.toISOString();
}

